import { render } from "./SettingsIcon.vue?vue&type=template&id=18287bde&scoped=true"
import script from "./SettingsIcon.vue?vue&type=script&lang=js"
export * from "./SettingsIcon.vue?vue&type=script&lang=js"

import "./SettingsIcon.vue?vue&type=style&index=0&id=18287bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18287bde"]])

export default __exports__